import React, { useEffect, useState, useLayoutEffect } from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';

const Modal = ({ children, ...props }) => {
  const [element, setElement] = useState(undefined);

  useEffect(() => {
    const modalRoot = document.getElementById('modal-root');
    const element = document.createElement('div');
    modalRoot.appendChild(element);
    setElement(element);
    return () => modalRoot.removeChild(element);
  }, []);

  useLayoutEffect(() => {
    let doc = document.documentElement;
    let top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);

    document.body.style.position = 'fixed';
    document.body.style.top = `-${top}px`;

    return () => {
      const scrollY = document.body.style.top;
      document.body.style.position = '';
      document.body.style.top = '';
      window.scrollTo(0, parseInt(scrollY || '0') * -1);
    };
  }, []);

  if (!element) return null;
  return ReactDOM.createPortal(
    <ModalStyled>
      <Box {...props}>{children}</Box>
    </ModalStyled>,
    element
  );
};


const ModalStyled = styled.div`
  z-index: 99;
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  display: flex;
  justify-content: center;
  animation: fadein 1s forwards;

  @keyframes fadein {
    from {
      background-color: rgba(0, 0, 0, 0);
    }
    to {
      background-color: rgba(0, 0, 0, 0.5);
    }
  }
`;

const Box = styled.div`
  border-radius: 20px;
  background-color: white;
  margin: auto 10px;
  max-width: 80%;
  max-height: 80%;
  overflow-y: auto;
`;

export default Modal;
